import { vModelDynamic as _vModelDynamic, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
    class: "form__input",
    onFocusin: _cache[0] || (_cache[0] = ($event: any) => (_ctx.focusIn($event))),
    onFocusout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.focusOut($event))),
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model) = $event)),
    value: _ctx.model || _ctx.value
  }, _ctx.$attrs, { ref: "input" }), null, 16, _hoisted_1)), [
    [_vModelDynamic, _ctx.model]
  ])
}